import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { BannerImage } from '../components/banner-image'
import { BlogSection } from '../components/blog-section'
import { Mbr } from '../components/br'
import { ContentContainer } from '../components/content-container'
import { DecoratedFrame } from '../components/decorated-frame'
import { Fqa } from '../components/fqa'
import { HeadBannar } from '../components/head-bannar'
import { HorizontalArticle, HorizontalArticleImageContainer, HorizontalArticleTextContainer, HorizontalArticleTitle, HorizontalArticleText, HorizontalArticleWithLargeGap, HorizontalArticleTitleWithColor } from '../components/horizontal-article'
import { Section } from '../components/section'
import { DiagramContainer, DiagramItem, ItemTitle, ItemText } from '../components/section-diagram'
import { SectionNavigator } from '../components/section-navigator'
import { SectionSpaceLarge, SectionSpaceMedium } from '../components/section-space'
import { SectionTextExtraLarge, SectionTextMedium, SectionTextSmall } from '../components/section-text'
import { SectionTitle } from '../components/section-title'
import { TableCell, TableHeadCell, TableOuter, TableRow } from '../components/table'
import { useFaqPostsQuery } from '../generated/graphql'
import { useBreakpoint } from '../hooks/use-breakpoint'

const Outer = styled.div``

const FaqHeadContainer = styled.div`
  img {
    display: block;
    height: 6rem;
    width: auto; 
  }
`

const FaqContainer = styled.div`
  width: 60rem;
  max-width: 100%;

`

type AdvantagePageProps = {

}
export const AdvantagePage: FunctionComponent<AdvantagePageProps> = () => {
  const isMobile = useBreakpoint('40rem')
  const faqPostsQuery = useFaqPostsQuery()
  return <Outer>
  <HeadBannar desktop={() => <BannerImage src="/images/header_07.jpg" />} mobile={() => <BannerImage src="/images/header_07_mobile.jpg" />}></HeadBannar>
  <ContentContainer>
    <SectionNavigator labelMap={new Map([
      ['phylosophy', 'PHYLOSOPHY'],
      ['features', 'FEATURES'],
      ['target', '保育目標'],
      ['faq', 'よくある質問'],
      ['about', '園の概要']
    ])} />
    <Section id="phylosophy">
      <SectionSpaceMedium />
      <SectionTitle>PHYLOSOPHY</SectionTitle>
      <SectionSpaceMedium />
      <DecoratedFrame leftTop="/images/dec_08_01.png" rightBottom="/images/dec_08_02.png">
        <AutoImage src="/images/img_14.jpg" mobileSrc="/images/img_14_mobile.jpg" />
      </DecoratedFrame>
      <SectionSpaceMedium />
      <SectionTextSmall>
        “ムロノキッズ”は「幼児教育だけでなく、<br />
        保育を必要とする就学前の子ども達が同じ場所で<Mbr />等しく育ちあえる温もりのある場にしたい」<br />
        という思いから名付け、<Mbr />“室の木の子ども達”を総称しています。<br />
        認定こども園法の立法趣旨からも、<Mbr />保護者の就労等の有無で幼稚園や保育園が決まるという<br />
        既存の制度にとらわれない、<Mbr />新しい幼児教育の場の提供が求められる中、<br />
        「子ども達を分け隔てなく見つめる場所」として、<Mbr />最も適した時代に即した環境です。
      </SectionTextSmall>
    </Section>
    <Section id="features" style={{maxWidth: '60rem', marginLeft: 'auto', marginRight: 'auto'}}>
      <SectionTitle>FEATURES</SectionTitle>
      <SectionSpaceMedium />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_15.jpg" mobileSrc="/images/img_15_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            一斉保育、<br />
            協力する遊び
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            リズム遊び、造型遊び、運動遊び、畑の活動など、集団ルールを学ぶ絶好の機会です。集団の中で自分の力を発揮する機会も増え、同じ目的に向かって友だちと一緒に考え、行動し、創造性、表現力、そして協調性と個性を育てます。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge /> 
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            自由遊び、<br />
            興味を伸ばす遊び
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            なかよし農園で草花を観察したり、園庭を駆け回ったり、各自が興味ある遊びに熱中する「自発的な遊び」の時間を設けています。3歳は一人遊びの充実、4歳はイメージをもとにしたごっこ遊び、5歳は造形、昆虫、おはなし作りなど、より高度な遊びを展開しています。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_16.jpg" mobileSrc="/images/img_16_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_17.jpg" mobileSrc="/images/img_17_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            健康と安全
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            子ども達の健康管理に万全を期すため健康診断（年間2回の内科・歯科検診、視聴覚検査など）を行います。また、教職員すべてが緊急な場合に対応出来るよう、日赤救急法の講習を受け認定証を保持しています。毎月の避難訓練（地震・火災）、交通安全教育も実施しています。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            “ぞうり”のすすめ
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            夏用上履きとして「ぞうり」を採用しています。足を使うことは脳に刺激を与えます。また足は第2の心臓とも言われ、健康な身体と心が育っていきます。運動や畑の活動を通して身体と意志を磨く「強い身体」を形成します。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_18.jpg" mobileSrc="/images/img_18_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_19.jpg" mobileSrc="/images/img_19_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            体操指導、音楽指導
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            運動は心と身体をバランス良く健やかに育てます。自分の身体は自分で守る運動感覚を身につけていきます。専門の指導員が週1回体操指導をしています。<br />
            音感は3〜9歳ごろ育つといわれています。美しい音色は子どもを心豊かに、心優しく育てます。いろいろな歌唱、リズム遊び、鍵盤ハーモニカを中心とした楽器を通して音楽を楽しみます。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            家庭との連携
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            月1回の園だより、クラスだより、行事活動の報告、おたよりノートなど、またICTによる情報配信など、さまざまな手段を使って、お子さまの園での様子を詳細にお知らせいたします。保育参観（各学期に1回）、保育参加（希望者）など直接お子さまをご覧いただく機会を設けてご理解いただいております。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_20.jpg" mobileSrc="/images/img_20_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_21.jpg" mobileSrc="/images/img_21_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            子育て相談
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            経験豊富な教諭による「子育て相談」を実施いたします。子どもの発育・発達や養育上の悩みなどの相談、しつけ、夜尿、チック、吃音、言葉の遅れ、性格、いじわる等の相談をお受けしています。港南及び中部療育センターとの連携も随時行っております。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            地域社会との関係
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            東永谷中央ケアプラザ、港南ケアプラザ、すずかけの里訪問（七夕、敬老の日）、港南警察署・港南消防署見学、近隣公園めぐり等、活動の中に地域社会見学が盛り込まれています。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_22.jpg" mobileSrc="/images/img_22_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_23.jpg" mobileSrc="/images/img_23_mobile.jpg" />
        </HorizontalArticleImageContainer>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            みのりの会<br />
            （保護者会）
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            みのりの会は各種の行事お手伝いを積極的に行っていくため及び父母の皆様と幼稚園との意思疎通の場として活動しています。また保護者全員の方に1年に1つ（以上）行事へご協力いただいております。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
      <HorizontalArticleWithLargeGap>
        <HorizontalArticleTextContainer style={{flex: '0 1 50%'}}>
          <HorizontalArticleTitleWithColor>
            英語保育<br />
            （年中より選択制）
          </HorizontalArticleTitleWithColor>
          <HorizontalArticleText>
            グローバル社会での活躍が期待し英語保育を実践しています。週3日以上英語に触れることで子ども達の知識欲を刺激し、英語脳を活性化することで英語を身近なものにしていきます。
          </HorizontalArticleText>
        </HorizontalArticleTextContainer>
        <HorizontalArticleImageContainer>
          <AutoImage src="/images/img_24.jpg" mobileSrc="/images/img_24_mobile.jpg" />
        </HorizontalArticleImageContainer>
      </HorizontalArticleWithLargeGap>
      <SectionSpaceLarge />
    </Section>
    <Section id="target">
      <SectionTitle>保育目標</SectionTitle>
      <SectionSpaceMedium />
      <DecoratedFrame leftTop="/images/dec_09_01.png" rightBottom="/images/dec_09_02.png">
        <AutoImage src="/images/img_25.jpg" mobileSrc="/images/img_25_mobile.jpg" />
      </DecoratedFrame>
      <SectionSpaceMedium />
      <SectionTextSmall>
        「小学校就学前教育および保育の提供」が、認定こども園に課されている目的の一つです。<br />
        子ども達の健やかな育ちを保証し、小学校へのスムースな進学へと導いていくための保育を実践していきます。
      </SectionTextSmall>
    </Section>
    <Section id="faq">
      <SectionTitle>よくある質問</SectionTitle>
      <SectionSpaceLarge />
      <FaqContainer>
        <Fqa faq={faqPostsQuery.data?.faqPosts?.nodes?.slice().sort((a, b) => (a?.faq_fields?.num ?? 0) - (b?.faq_fields?.num ?? 0)).map(faq => ({number: faq?.faq_fields?.num ?? 0, question: faq?.title ?? '', answer: faq?.faq_fields?.answer ?? ''})) ?? []} />
      </FaqContainer>
    </Section>
    <Section id="about">
      <SectionTitle>園の概要</SectionTitle>
      <SectionSpaceMedium />
      {
        isMobile ?
        <DiagramContainer>
          <DiagramItem>
            <ItemTitle>正式園名</ItemTitle>
            <ItemText>学校法人北見学園　認定こども園ムロノキッズ　室の木幼稚園・プリスクール室の木</ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>住所</ItemTitle>
            <ItemText>〒233-0003　神奈川県横浜市港南区港南3-35-20</ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>電話番号</ItemTitle>
            <ItemText>電話番号 ：045-844-1107　FAX番号 ：045-844-1367</ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>設立</ItemTitle>
            <ItemText>昭和52年5月9日</ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>事業内容</ItemTitle>
            <ItemText>
              幼稚園部門：室の木幼稚園　保育所部門：プリスクール室の木<br />
              <br />
              この2施設を有機的に結合した新しい形の幼児施設である〈認定こども園ムロノキッズ〉の認定を神奈川県より平成19年4月に受け、平成27年4月1日に新たに〈認定こども園ムロノキッズ 室の木幼稚園・プリスクール室の木〉として単独の乳幼児教育施設としての認可を横浜市より受けております。</ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>代表者</ItemTitle>
            <ItemText>
              理事長　：村田晃　幼稚園長：北見宏
            </ItemText>
          </DiagramItem>
          <DiagramItem>
            <ItemTitle>従業員数</ItemTitle>
            <ItemText>幼稚園教諭・保育士：40名、事務職：2名、英語教諭、運転手、パートほか総勢50名</ItemText>
          </DiagramItem>
        </DiagramContainer> :
        <TableOuter>
          <TableRow>
            <TableHeadCell>正式園名</TableHeadCell>
            <TableCell>学校法人北見学園　認定こども園ムロノキッズ　室の木幼稚園・プリスクール室の木</TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>住所</TableHeadCell>
            <TableCell>〒233-0003　神奈川県横浜市港南区港南3-35-20</TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>電話番号</TableHeadCell>
            <TableCell>電話番号 ：045-844-1107　FAX番号 ：045-844-1367</TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>設立</TableHeadCell>
            <TableCell>昭和52年5月9日</TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>事業内容</TableHeadCell>
            <TableCell>
              幼稚園部門：室の木幼稚園　保育所部門：プリスクール室の木<br />
              <br />
              この2施設を有機的に結合した新しい形の幼児施設である〈認定こども園ムロノキッズ〉の認定を神奈川県より平成19年4月に受け、平成27年4月1日に新たに〈認定こども園ムロノキッズ 室の木幼稚園・プリスクール室の木〉として単独の乳幼児教育施設としての認可を横浜市より受けております。</TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>代表者</TableHeadCell>
            <TableCell>
              理事長　：村田晃　幼稚園長：北見宏
            </TableCell>
          </TableRow>
          <TableRow>
            <TableHeadCell>従業員数</TableHeadCell>
            <TableCell>幼稚園教諭・保育士：40名、事務職：2名、英語教諭、運転手、パートほか総勢50名</TableCell>
          </TableRow>
        </TableOuter>
      }
    </Section>
    <BlogSection />
  </ContentContainer>
  </Outer>
}